import { events } from '~features/annals';
import { useSendEvent } from '~features/annals/useSendEvent';

export const useBotProfileOpened = ({
	source,
	botClientId,
}: {
	source: 'menu' | 'gallery';
	botClientId: string;
}) =>
	useSendEvent(events.botProfile.botProfileOpened, {
		source,
		bot_UserId: botClientId,
	});

export const useCreateMediaOpenedFromBotProfile = ({
	botClientId,
}: {
	botClientId: string;
}) =>
	useSendEvent(events.botProfile.mediaGenOpened, {
		bot_UserId: botClientId,
	});

export const useChatOpenedFromBotProfile = ({
	botClientId,
}: {
	botClientId: string;
}) =>
	useSendEvent(events.botProfile.chatOpened, {
		bot_UserId: botClientId,
	});
